import type { LoadingGridProps } from './types'

import * as S from './styles'

export const Loading = ({ hasText = true, size = 'medium', colorType = 'outline' }: LoadingGridProps) => {
  const sizeMap = {
    small: 18,
    medium: 50,
    large: 100
  }

  return (
    <S.Container>
      <S.Loading enableTrackSlot size={sizeMap[size]} thickness={7} colorType={colorType} />
      {hasText ? <S.LoadingText>Carregando...</S.LoadingText> : null}
    </S.Container>
  )
}
